import { getQueryParamsFun } from "@/store/home";
import { dayjs } from "element-plus";
import type { PsgTypeWithNumItem } from "../home/model";

//护照正则表达式 
export const PASSPORT = /^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)|(^[\d]{16}$)|(^[a-zA-Z\d]{7,10}$)/;
// 校验乘客年龄是否合规
export const checkPsgBirthday = (type: number, birthday: string) => {
    console.log(type, type);
    const queryParam = getQueryParamsFun();
    const depDate = queryParam.tripType === '2' ? queryParam.retDate : queryParam.fromDate;
    const age = getAge(birthday, depDate);
    switch (type) {
        case 0:
            return age > 11 ? true : false;
            break;
        case 1:
            return (age > 1 && age < 12) ? true : false;
            break;
        case 2:
            return age < 2 ? true : false;
            break;
        default:
            return false;
            break;
    }
};

const getAge = (birthday: string, depDate: string) => {
    console.log(birthday, depDate);
    return dayjs(depDate).diff(dayjs(birthday), 'year');
};

// 将日期根据语言进行调整(YYYY-MM-DD)
export const convertDate = (date: string, lang: string) => {
    if (date) {
        if (lang === 'En') {
            const dateList = date.split('-');
            return dateList[2] + '-' + dateList[1] + '-' + dateList[0];
        }
        return date;
    }
    return '';
};
// 将日期根据语言进行调整(YYYY/MM/DD)
export const convertDate2 = (date: string, lang: string) => {
    if (date && date.indexOf('/') !== -1) {
        if (lang === 'En') {
            const dateList = date.split('/');
            return dateList[2] + '/' + dateList[1] + '/' + dateList[0];
        }
        return date;
    } else if (date && date.indexOf('-') !== -1) {
        if (lang === 'En') {
            const dateList = date.split('-');
            return dateList[2] + '/' + dateList[1] + '/' + dateList[0];
        }
        return date;
    }
    return '';
};























export const addPsgNum = (type: number, tempPsg: PsgTypeWithNumItem[]) => {
    switch (type) {
        case 0:
            tempPsg[0].actNum = tempPsg[0].actNum + 1;
            break;
        case 1:
            tempPsg[1].actNum = tempPsg[1].actNum + 1;
            break;
        case 2:
            tempPsg[2].actNum = tempPsg[2].actNum + 1;
            break;
        case 3:
            tempPsg[3].actNum = tempPsg[3].actNum + 1;
            break;
        case 4:
            tempPsg[4].actNum = tempPsg[4].actNum + 1;
            break;
        case 5:
            tempPsg[5].actNum = tempPsg[5].actNum + 1;
            break;
    }
    const count: number = tempPsg.reduce((acc: number, item: any) => {
        return acc + item.actNum;
    }, 0);
    return { list: tempPsg, count: count };
};

export const minusPsgNum = (type: number, tempPsg: PsgTypeWithNumItem[]) => {
    switch (type) {
        case 0:
            tempPsg[0].actNum = tempPsg[0].actNum - 1;
            if (tempPsg[2].actNum > tempPsg[0].actNum) {
                tempPsg[2].actNum = tempPsg[0].actNum;
            }
            if (tempPsg[1].actNum > 0) {
                if (tempPsg[2].actNum + tempPsg[1].actNum > tempPsg[0].actNum * 2) {
                    tempPsg[1].actNum = tempPsg[1].actNum - 1;
                    if (tempPsg[2].actNum + tempPsg[1].actNum > tempPsg[0].actNum * 2) {
                        tempPsg[1].actNum = tempPsg[1].actNum - 1;
                    }
                }
            }
            break;
        case 1:
            tempPsg[1].actNum = tempPsg[1].actNum - 1;
            break;
        case 2:
            tempPsg[2].actNum = tempPsg[2].actNum - 1;
            break;
        case 3:
            tempPsg[3].actNum = tempPsg[3].actNum - 1;
            break;
        case 4:
            tempPsg[4].actNum = tempPsg[4].actNum - 1;
            break;
        case 5:
            tempPsg[5].actNum = tempPsg[5].actNum - 1;
            break;
    }
    let count: number = tempPsg.reduce((acc: number, item: any) => {
        return acc + item.actNum;
    }, 0);
    return { list: tempPsg, count: count };
};